import React, {FC} from "react";
import {useIntl} from "react-intl";
import ReceiptProducts from "./ReceiptProducts";
import { PageTitle } from "../../../_metronic/layout/core";

const ConsignmentSalesWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle
        breadcrumbs={breadcrumbs}>Sản phẩm ký gửi đã bán</PageTitle>
      <ReceiptProducts/>
    </>
  )
}
export default ConsignmentSalesWrapper;